import React from 'react';
import styles from './Approvals.module.css';

function Approvals() {
  return (
    <div className={styles.approvals}>Approvals</div>
  )
}

export default Approvals